export default __webpack_public_path__ + "static/media/Hoos Hip Disability and Osteoarthritis Outcome.a0964158.pdf";